import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchIdentityProviderTE = <E = CF.API.ApiError>(
  { orgId, identityProviderId }: { orgId: string; identityProviderId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.FetchIdentityProviderResponse> =>
  fetchTE<CF.API.Organizations.FetchIdentityProviderResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/identity_providers/${identityProviderId}`,
      method: 'GET',
    },
    onRejected,
  );
